module.exports = __webpack_public_path__ + "media/images/menu/csm_united-kingdom-84ae4f8967486c385744d71a902d4722.png";